import React from 'react';
import { Wrapper, Subtitle, Title, Button, Options } from './styled';
import Option from '~/src/components/Presentation/Option';
import { num2str } from '~/src/helpers/formatter';

const Header = ({ subtitle, title, buttonText, link, properties: { speed, channels }, productProperties, textColor = null, productMeta, isRKTariff }) => {

    const onClickButtonHandler = () => {
        if (isRKTariff) {
            window.fbq('track', 'Lead');
            window._tmr?.push({ id: '3213734', type: 'reachGoal', goal: 'Lead' });
        }
        window.location = link;
    };

    return (
        <Wrapper textColor={textColor}>
            <Title itemProp='name' dangerouslySetInnerHTML={{ __html: title }} />
            <Subtitle dangerouslySetInnerHTML={{ __html: subtitle }} />
            <Options>
                {
                    Boolean(speed) &&
                    <Option
                        key='speed'
                        value={speed}
                        text='Мбит/с'
                        description='скорость интернета'
                    />
                }
                {
                    Boolean(isRKTariff) &&
                    <Option
                        key='RKchannels'
                        value='от 110'
                        text='ТВ-каналов'
                        description='в подарок'
                    />
                }
                {
                    Boolean(channels) &&
                    <Option
                        key='channels'
                        value={channels}
                        text={num2str(channels, ['ТВ-канал', 'ТВ-канала', 'ТВ-каналов'])}
                        description='телевидение'
                    />
                }
                {
                    // кастомное свойство
                    productProperties && productProperties.map(option => {
                        return <Option
                            key={option.key}
                            value={option.value}
                            text={num2str(channels, option.unitDeclension)}
                            description={option.description}
                        />;
                    })
                }
            </Options>

            {productMeta}

            <Button text={buttonText} onClick={onClickButtonHandler} />
        </Wrapper>
    );
};

export default Header;
